import { IonApp, IonButton, IonContent } from "@ionic/react";
import React, { Component } from "react";
import Toolbar from "../../components/Toolbar";
import "./style.css";
// import AdSense from "react-adsense";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import { URLS } from "../../urls";
import Firebase from "../../firebase";

class Rules extends Component {
    state = { rules: "" };

    async componentDidMount() {
        await this.setState({
            rules: (await Firebase.getInstance().readData("/data/Misc")).rules,
        });
    }

    render() {
        return (
            <IonApp>
                <Toolbar />
                <IonContent>
                    <h1 className="rules__h1">חוקי ספסליג</h1>
                    <div className="rules__div">
                        {this.state.rules.split("\n").map((txt: any) => {
                            return <div key={txt}>{txt}</div>;
                        })}
                    </div>

                    <Link to={URLS.MY_TEAM.url}>
                        <IonButton>התחילו לשחק! </IonButton>
                    </Link>

                    {/* <AdSense.Google
                    client="ca-pub-2967708817373145"
                    slot="5134489714"
                    style={{ width: 500, height: 300, float: "bottom" }}
                    format=""
                /> */}
                    <br />
                    <Footer />
                </IonContent>
            </IonApp>
        );
    }
}

export default Rules;
